var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 39.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ea1d2c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,22.75h5.71l3.17-15.78H3.17L0,22.75ZM3.49,5.1h5.73l.94-4.72h-5.73l-.94,4.72Zm4.44,22.1h5.71l3.49-17.05h4.28l.63-3.17h-4.2l.16-.71c.24-1.34.71-2.85,2.85-2.85,1.27,0,2.46.08,3.65.63l.63-3.33c-1.32-.47-2.72-.71-4.12-.71-4.6,0-7.77,2.7-8.96,6.98h-1.98l-.63,3.17h1.98l-3.49,17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26,23.07c6.74,0,11.42-6.11,11.42-11.1,0-3.73-3.41-5.31-6.74-5.31-7.38,0-11.42,6.58-11.42,11.1,0,3.73,3.49,5.31,6.74,5.31m18.08,0c6.74,0,11.42-6.11,11.42-11.1,0-3.73-3.49-5.31-6.82-5.31-7.37,0-11.42,6.58-11.42,11.1,0,3.73,3.57,5.31,6.82,5.31m20.69-.32h5.63L75,.32h-5.71l-1.35,6.66-2.38-.24c-5.55,0-10.62,7.13-10.62,12.21,0,2.06,1.34,4.12,3.65,4.12,3.25,0,5.55-1.59,6.5-3.17h.32l-.63,2.85Zm-17.6,11.81c-4.43,3.67-10.12,5.46-15.86,4.99-7.53-.48-12.92-6.26-13.87-12.37h.32c1.74,3.81,5.95,7.37,11.1,7.93,5.23.63,11.5-1.74,14.9-4.99l-3.81-2.93h11.5l-2.54,12.21-1.67-4.76-.08-.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfood);
export default __webpack_public_path__ + "static/media/Ifood.297b78a72426e2d23e9b16338154c8a7.svg";
export { ForwardRef as ReactComponent };